import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import AuthProvider from './contexts/AuthProvider';
import UIProvider from './contexts/UIProvider';
import AppRoutes from './routes';
import ACMProvider from './contexts/ACMProvider';
import { UserDataProvider } from './contexts/userDataContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { PaymentProvider } from './contexts/PaymentContext';
import { ClinicalSessionProvider } from './contexts/ClinicalSessionContext';
import ClinicalSessionDialog from './components/ClinicalSession/ClinicalSessionDialog';
import MinimizedSessionsBar from './components/ClinicalSession/MinimizedSessionsBar';
import theme from './theme';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity, // Data never becomes stale automatically
      gcTime: 30 * 60 * 1000, // 30 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      // Prevent background refetching
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
    mutations: {
      // Prevent retries on mutations
      retry: false,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UIProvider>
            <ACMProvider>
              <UserDataProvider>
                <NotificationProvider>
                  <PaymentProvider>
                    <ClinicalSessionProvider>
                      <AppRoutes />
                      <ClinicalSessionDialog />
                      <MinimizedSessionsBar />
                    </ClinicalSessionProvider>
                  </PaymentProvider>
                </NotificationProvider>
              </UserDataProvider>
            </ACMProvider>
          </UIProvider>
        </AuthProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
